import { render } from "./opinion-bar-button-wrapper.vue?vue&type=template&id=49e9d0f9&scoped=true"
import script from "./opinion-bar-button-wrapper.vue?vue&type=script&lang=js"
export * from "./opinion-bar-button-wrapper.vue?vue&type=script&lang=js"

import "./opinion-bar-button-wrapper.vue?vue&type=style&index=0&id=49e9d0f9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e9d0f9"]])

export default __exports__